import { createFileRoute } from '@tanstack/react-router'
import { ProspectPage } from '~/features/scouting/ProspectPage'
import { prospectQuery } from '~/features/scouting/queries'

export const Route = createFileRoute('/_app/kader/talente/$prospectId')({
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(prospectQuery(params.prospectId)).catch(() => undefined)
  },
  component: function Talent() {
    return <ProspectPage prospectId={Route.useParams().prospectId} />
  },
})
